import {useDispatch, useSelector} from 'react-redux';
import {ButtonProps, IconButton, Tooltip} from '@mui/material';
import IconPlay from '../../asset/icons/icon_play.svg';
import IconPause from '../../asset/icons/icon_pause.svg';
import {playSong, togglePlayerState} from '../../store/Slices/playerSlice';
import {RootState} from '../../store/configstore';

type Props = {
  id: string | number | null;
  url: string;
  size?: boolean;
  track_name: string;
  track_artist: string;
  buttonProps?: ButtonProps;
  toolTipLabel?: string;
};

const MusicPreviewBtn = ({
  id,
  url,
  size,
  track_name,
  track_artist,
  buttonProps,
  toolTipLabel = '',
}: Props) => {
  const dispatch = useDispatch();

  const {
    songUrl,
    id: currentId,
    isPlaying,
  } = useSelector((state: RootState) => state.player);

  const sizeSet = size ? {width: '29px', height: '29px'} : {};

  const handleClick = () => {
    if (songUrl === url && currentId === id) {
      dispatch(togglePlayerState());
    } else {
      dispatch(playSong({songUrl: url, track_name, track_artist, id: id || 0}));
    }
  };

  return (
    <Tooltip title={toolTipLabel}>
      <IconButton
        className='p-0'
        aria-label='play'
        onClick={handleClick}
        {...buttonProps}
        disabled={!url || url.trim() === ''}>
        <img
          src={isPlaying && currentId === id ? IconPause : IconPlay}
          alt=''
          style={sizeSet}
        />
      </IconButton>
    </Tooltip>
  );
};

export default MusicPreviewBtn;

export const MusicPreviewBtnDisable = () => (
  <IconButton aria-label='play' disabled={true}>
    <img src={IconPlay} alt='' />
  </IconButton>
);
